import * as types from "./mutation_types";

export default {
  [types.TYPE_RELANCE_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.TYPE_RELANCE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.TYPE_RELANCE_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.TYPE_RELANCE_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
